import {getToken, setToken, removeToken, setActiveWebsite} from "../../utilis/auth";
import {getUser, login, register, logout, resend, update} from "../../api/user";
import store from '../index';
import Cookies from 'js-cookie';
import Vue from 'vue';
import router from '../../router';
import {deleteIntegrationsFromCookiesByType} from "@/utilis/integration_cookies";
const state = {
    user: {},
    location:null,
};
const actions = {
    getLocation: ({state}) => {
        return new Promise((resolve, reject) => {
            navigator.geolocation.getCurrentPosition((position) => {
                var lat = position.coords.latitude;
                var lng = position.coords.longitude;
                state.location = {lat: null, lng: null};
                state.location.lat = lat;
                state.location.lng = lng;
                resolve(state.location);
            }, () => {
                state.location = 'denied';
                reject();
            });
        })
    },
    checkLocation: ({commit, state}) => {
        if (navigator.geolocation) {
            navigator.permissions.query({ name: 'geolocation' })
                .then((params) => {
                 if(params.state == 'prompt'){
                    state.location = 'no_ask';
                 }
                 if(params.state == 'denied'){
                     state.location = 'denied';
                 }
                });

        } else {
            alert("Geolocation is not supported by this browser.");
        }
    },
    update: ({commit}, data) => {
      return new Promise((resolve, reject) => {
          update(data.data, data.id).then(response => {
              resolve(response);
          }).catch(e => {
              reject(e);
          })
      })
    },
    getUser: ({ commit }, relations = []) => {
        return new Promise((resolve, reject) => {
            relations.push('website_role');
            getUser({relations}).then(response => {
                commit('setUser', response);
                resolve(response);
            }).catch(e => {
                removeToken();
                router.push('/login?first_time=true');
                reject(e);
            })
        })
    },
    logout: ({commit, dispatch}) => {
      return new Promise((resolve, reject) => {
          logout().then(response => {
              commit('setUser', {});
              Cookies.set('active_website', 0);
              dispatch('websites/setActive', null, {root: true});
              removeToken();
              router.push('/login');
              store.commit('websites/SET_WEBSITES', null);
              store.dispatch('app/getProgress', true);
              resolve();
          }).catch(e => {
              reject(e);
          })
      })
    },
    login: ({commit}, data) => {
        return new Promise((resolve, reject) => {
            login(data).then(response => {
                commit('setUser', response.user);
                setToken(response.access_token);
                store.dispatch('app/getProgress', true);
                if(response.website) {
                    Cookies.set('active_website', response.website.id);
                    deleteIntegrationsFromCookiesByType('shopify');
                    // store.commit('websites/SET_WEBSITES', response.website);
                }
                resolve();
            }).catch(e => {
                reject(e);
            })
        })

    },
    register: ({commit, dispatch}, data) => {
        return new Promise((resolve, reject) => {
            register(data).then(response => {
                resolve(response);
            }).catch(e => {
                reject(e);
            })
        })
    }
};

const mutations = {
    setUser: (state, user) => {
        (user.roles && user.roles.findIndex(x => x.name == 'example') != -1)? user.is_example = true : user.is_example = false;
        state.user = user
    },
    setField: (state, payload) => {
        Vue.set(state.user, payload.field, payload.data);
    },
};

const getters = {
    user: state => state.user
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
